module.exports = __webpack_public_path__ + "assets/img/remix-icons-fill-design.1fff9ff2.svg";